<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eqBMP6/tc-custom/9781504062510.jpg?1718078716138" alt="This image is the cover for the book Window at the White Cat"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Window at the White Cat
      </h1>
      <p class="bookDescription body article font2">
        <b>A missing person sets off the action in this classic whodunit from the bestselling mystery writer known as the American Agatha Christie.</b><br/>  <br/> In <i>The Window at the White Cat</i>, bumbling lawyer Jack Knox agrees to help a beautiful young woman find her missing father. But when the politician is found dead at a backstreet social club serving up beers and illegal favors, and Jack’s aunt disappears, it looks like the daughter’s fiancé may be guilty of more than winning her heart.<br/>  <br/> A #1 <i>New York Times</i>–bestselling author with ten million books in print, Mary Roberts Rinehart crafted a career out of writing mysteries that set the stage for generations of writers to come.<br/>  <br/> “[Rinehart’s] literary distinction lies in the combination of love, humor and murder that she wove into her tales. . . . She helped the mystery story grow up.”—<i>The New York Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Roberts Rinehart
      </h2>
      
      <p class="authorDescription body article">Mary Roberts Rinehart (1876&ndash;1958) was one of the United States&rsquo;s most popular early mystery authors. Born in Pittsburgh to a clerk at a sewing machine agency, Rinehart trained as a nurse and married a doctor after her graduation from nursing school. She wrote fiction in her spare time until a stock market crash sent her and her young husband into debt, forcing her to lean on her writing to pay the bills. Her first two novels, <i>The Circular Staircase</i> (1908) and <i>The Man in Lower Ten</i> (1909), established her as a bright young talent, and it wasn&rsquo;t long before she was one of the nation&rsquo;s most popular mystery novelists.<BR>Among her dozens of novels are <i>The Amazing Adventures of Letitia Carberry</i> (1911), which began a six-book series, and <i>The Bat</i> (originally published in 1920 as a play), which was among the inspirations for Bob Kane&rsquo;s Batman. Credited with inventing the phrase &ldquo;The butler did it,&rdquo; Rinehart is often called an American Agatha Christie, even though she began writing much earlier than Christie, and was much more popular during her heyday.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8f915c58